import { useState, useEffect } from "react";
import { GroupMemberInfo } from "../types/gigya";
import { API_REGION_VERSION_MAP } from "../utils";
import axios from "axios";

const removeHyphen = (hyphenatedLocale: string) => {
  const region = hyphenatedLocale.split("-")[1].toUpperCase();
  return hyphenatedLocale.split("-")[0] + region;
};

export const useGetMembers = (
  myUID: string | undefined,
  groupId: string | undefined,
  status?: string | undefined,
) => {
  const [membersError, setMembersError] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(true);
  const [members, setMembers] = useState<Array<GroupMemberInfo>>([]);
  const [newGroupId, setNewGroupId] = useState<string | undefined>(groupId);
  const [paginationStart, setPaginationStart] = useState(0);
  const [paginationLimit, setPaginationLimit] = useState(5);
  const [paginationTotalCount, setPaginationTotalCount] = useState(0);
  const apiVersion =
    API_REGION_VERSION_MAP[removeHyphen(process.env.REACT_APP_LOCALE!)];

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (myUID && groupId) {
      setLoadingMembers(true);
      window.gigya.accounts.getJWT({
        UID: myUID || "",
        callback: (resp) => {
          if (resp["errorCode"] === 0) {
            const headers = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${resp.id_token}`,
            };
            const apiKey = process.env.REACT_APP_CDC_API_KEY ?? "";
            const GetMembersUrl = `${process.env.REACT_APP_CDC_API_BASEURL}/${process.env.REACT_APP_CDC_API_VERSION}/cdc/groups/getMembers`;
            const GetMembersUrlTW = `${process.env.REACT_APP_CDC_API_BASEURL}/${apiVersion}/cdc/groups/getMembers`;
            axios
              .post(
                process.env.REACT_APP_LOCALE !== "en-us"
                  ? GetMembersUrlTW
                  : GetMembersUrl,
                {
                  apiKey,
                  groupId: newGroupId || groupId,
                  start: paginationStart,
                  limit: paginationLimit,
                  status,
                },
                { headers, signal },
              )
              .then((res) => {
                setMembers(res.data.results);
                setPaginationTotalCount(res.data.totalCount);
                setLoadingMembers(false);
                setMembersError(false);
              })
              .catch((error) => {
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log("Error Data: ", error.response.data);
                  console.log("Erorr Status: ", error.response.status);
                  console.log("Error Headers: ", error.response.headers);
                  // setMembers([]);
                  setLoadingMembers(true);
                  setMembersError(true);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log(
                    "There was an error with your request: ",
                    error.request,
                  );
                  // setMembers([]);
                  setLoadingMembers(true);
                  setMembersError(true);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log("Error: ", error.message);
                  // setMembers([]);
                  setLoadingMembers(true);
                  setMembersError(true);
                }
                console.log("Error config: ", error.config);
                // setMembers([]);
                setLoadingMembers(true);
                setMembersError(true);
              });
          }
        },
      });
    }

    return () => {
      setMembers([]);
      controller.abort();
    };
  }, [myUID, groupId, newGroupId, paginationStart]);

  return {
    members,
    setMembers,
    setNewGroupId,
    loadingMembers,
    membersError,
    paginationStart,
    setPaginationStart,
    paginationLimit,
    paginationTotalCount,
  };
};
